<template>
	<el-date-picker v-if="model"
					v-model="model[data.fieldId]"
					:type="data.setting.type"
					:prefix-icon="data.setting.prefixIcon"
					:format="data.setting.format"
					:value-format="data.setting.valueFormat"
					:placeholder="data.placeholder"
					:disabled="disabled"
					@change="dateChange"
					style="width: 100%">
	</el-date-picker>
	<el-date-picker v-else
					v-model="data.value"
					:type="data.setting.type"
					:prefix-icon="data.setting.prefixIcon"
					:format="data.setting.format"
					:value-format="data.setting.valueFormat"
					:placeholder="data.placeholder"
					:disabled="disabled"
					@change="dateChange"
					style="width: 100%">
	</el-date-picker>
</template>

<script>
import { isHaveKey } from '../../utils/tool'

export default {
	name: 'TpDatePicker',
	props: {
		data: {
			type: Object,
			required: true
		},
		model: Object
	},
	inject: [ 'customFormOptions' ],
	computed: {
		disabled() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'disabled')) {
				return this.customFormOptions[this.data.fieldId].disabled(this.model[this.data.fieldId])
			} else {
				return false
			}
		}
	},
	methods: {
		dateChange(val) {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'change')) {
				this.customFormOptions[this.data.fieldId].change(val)
			}
		}
	}
}
</script>